import React from 'react';
import Slider from 'rc-slider';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import scriptLoader from 'react-async-script-loader';
import Loader from 'components/layout/Loader';
import { GOOGLE_MAPS_URL } from 'js/constants';

import FormInput from 'components/forms/FormInput';

class CmsElementMap extends React.Component {
  // use google geocoding to get the position
  getPosition = address => {
    this.setState({ posDetectPending: true, posDetectError: false }, () => {
      geocodeByAddress(address)
        .then(results => {
          getLatLng(results[0]).then(latLng => this.setPosDetectResult(results[0], latLng));
        })
        .catch(error => this.setState({ posDetectPending: false, posDetectError: true }));
    });
  };

  // get the google geocoding result and update the state
  setPosDetectResult = (result, latLng) => {
    this.setState(
      {
        address: result.formatted_address,
        location: latLng.lat + ',' + latLng.lng,
        posDetectPending: false,
        posDetectError: false,
      },
      () => {
        this.props.setParams([{ name: 'mapLat', value: latLng.lat }, { name: 'mapLng', value: latLng.lng }]);
      }
    );
  };

  render() {
    const {
      intl: { messages },
      getParamValue,
      setParam,
      isScriptLoaded,
      navigateBack,
    } = this.props;

    const mapHeight = parseInt(getParamValue('mapHeight', 300), 10);

    if (!isScriptLoaded) {
      return <Loader />;
    }

    return (
      <>
        <div className="m-b-20">
          <a
            href="#back"
            className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-5 p-b-5 text-master b-rad-lg"
            onClick={navigateBack}
          >
            <i className="fa fa-angle-left m-r-5" /> {messages.back}
          </a>

          <b>{messages.map}</b>
        </div>

        <div class="form-group-attached">
          <div class="form-group form-group-default">
            <label>
              {messages.height} {mapHeight + 'px'}
            </label>
            <Slider value={mapHeight} min={100} max={600} step={20} onChange={value => setParam('mapHeight', value)} />
          </div>
          <FormInput
            label={messages.address}
            name="mapAddress"
            value={getParamValue('mapAddress', '')}
            onChange={(name, value) => {
              setParam(name, value);
              this.getPosition(value);
            }}
          />
        </div>
      </>
    );
  }
}

export default scriptLoader(GOOGLE_MAPS_URL)(CmsElementMap);
